import { createSelector } from '@ngrx/store';
import { selectFilterState } from '../filter.selectors';
import { FilterState, RegionFilterState } from '@immosky/types';

export const selectRegionFilterState = createSelector(
  selectFilterState,
  (state: FilterState) => state.region
);

export const selectRegionFilters = createSelector(
  selectRegionFilterState,
  (state: RegionFilterState) => state.regions
);

export const selectInitialSearchTerm = createSelector(
  selectRegionFilterState,
  (state: RegionFilterState) => state.initialSearchTerm
);
